import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MailboxService {
  endpoint = environment.apiUrl + 'PLD/Administracioncasos/';
  // endpoint = 'https://localhost:5208/Administracioncasos/'; //aqui A208

  constructor(private http: HttpClient) {
  }

  obtenerPersonasBuzon(values: any): Observable<any> {
    return this.http.post<any>(
      this.endpoint + 'obtener/persona',
      JSON.stringify(values)
    );
  }

  guardarMailbox(values: any): Observable<any> {
    return this.http.post<any>(
      this.endpoint + 'mailbox',
      JSON.stringify(values)
    );
  }
}

